import { render } from "./ProductComposeModal.vue?vue&type=template&id=25e64d26"
import script from "./ProductComposeModal.vue?vue&type=script&lang=js"
export * from "./ProductComposeModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\jm.loc\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__